export default "__VITE_ASSET__CwbH2Uzz__"